/**
 * Static fallback configuration.
 *
 * These values are used when the engine's brand config hasn't loaded yet
 * (first render) or when the app is running without a network connection.
 * Any field here can be overridden via the Admin Dashboard → Application Settings
 * → Engagement App section, which saves to the DB and is fetched at runtime.
 */
export const APP_CONFIG = {
  needsAdditionalInfo: false,

  // Legal Links
  legal: {
    terms:        '/terms-and-conditions',
    cookiePolicy: '/terms-and-conditions'
  },

  // Social Media Links
  socialMedia: [],

  // Campaign Info (DB values take precedence at runtime via BrandConfigContext)
  campaign: {
    name:        'Campaign',
    description: 'Enter your code and stand a chance to win amazing prizes. <br />Every entry brings you closer to winning!',
    country:     '',
    year:        new Date().getFullYear()
  },

  // Welcome screen defaults
  content: {
    welcomeTitle:    'Unlock the magic in every meal',
    welcomeSubtitle: 'Share the joy with Coke — you could be a daily millionaire!',
    welcomeCta:      'Ready to create wonderful meal moments?',
    welcomeImageUrl: '/assets/images/app-image/home.png'
  }
};

export default APP_CONFIG;
